import { fetcher } from '@insta-club/api';
import { ArchiveFillIcon, ArchiveIcon, EyeIcon, HeartFillIcon, HeartIcon } from '@insta-club/components';
import { Reel } from '@insta-club/models';
import { cn } from '@insta-club/utilities';
import { useState } from 'react';
import useSWRMutation from 'swr/mutation';

interface Props {
    slide: Reel;
}

async function toggleFetcher(url: string, { arg }: { arg: string }) {
    await fetcher(`${url}${arg}`, 'dashboard', 'GET');
}

const ReelsMenu: React.FC<Props> = ({ slide }) => {
    const [like, setlike] = useState({ liked: !!slide.liked, count: slide.likes });
    const [mark, setMark] = useState({
        marked: !!slide.marked,
        count: slide.marks
    });
    const { trigger: likeTrigger, isMutating: likeMutation } = useSWRMutation('/reels/toggle', toggleFetcher);
    const { trigger: markTrigger, isMutating: markMutation } = useSWRMutation('/reels/toggle', toggleFetcher);

    const hanldeLikeToggle = async (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        try {
            setlike((prev) => ({
                liked: !prev.liked,
                count: prev.liked ? prev.count - 1 : prev.count + 1
            }));
            await likeTrigger(`/${slide.id}/like`);
        } catch {
            setlike((prev) => ({
                liked: !prev.liked,
                count: prev.liked ? prev.count - 1 : prev.count + 1
            }));
        }
    };

    const hanldeMarkToggle = async (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        try {
            setMark((prev) => ({
                marked: !prev.marked,
                count: prev.marked ? prev.count - 1 : prev.count + 1
            }));
            await markTrigger(`/${slide.id}/mark`);
        } catch {
            setMark((prev) => ({
                marked: !prev.marked,
                count: prev.marked ? prev.count - 1 : prev.count + 1
            }));
        }
    };

    return (
        <ul className='w-fit space-y-2 self-end text-white'>
            <li className='flex cursor-pointer flex-col gap-1 text-center'>
                <button
                    onClick={hanldeLikeToggle}
                    disabled={likeMutation}
                    className={cn('cursor-pointer', {
                        'animate-pulse': likeMutation,
                        'text-red-500': like.liked,
                        'text-white': !like.liked
                    })}
                >
                    {like.liked ? <HeartFillIcon width={20} height={20} /> : <HeartIcon width={20} height={20} />}
                </button>
                <span className='text-xs font-semibold'>{like.count}</span>
            </li>
            <li className='flex cursor-pointer flex-col gap-1 text-center'>
                <button
                    onClick={hanldeMarkToggle}
                    disabled={markMutation}
                    className={cn('cursor-pointer', {
                        'animate-pulse': markMutation,
                        'text-primary-500': mark.marked,
                        'text-white': !mark.marked
                    })}
                >
                    {mark.marked ? <ArchiveFillIcon width={20} height={20} /> : <ArchiveIcon width={20} height={20} />}
                </button>
                <span className='text-xs font-semibold'>{mark.count}</span>
            </li>
            <li className='flex cursor-pointer flex-col gap-1 text-center'>
                <EyeIcon width={20} height={20} className='text-white' />
                <span className='text-xs font-semibold'>{slide.views}</span>
            </li>
        </ul>
    );
};

export default ReelsMenu;

